import { RadioGroup, SxProps } from "@outschool/backpack";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import {
  Filter,
  FilterDropdown,
  FilterList
} from "@outschool/ui-components-website";
import React, { ReactNode } from "react";

type SessionDurationFilterProps = {
  open: boolean;
  handleImplicitFilterChange: (category: string, value: object) => void;
  onClose: () => void;
  onOpen: () => void;
  buttonSx?: SxProps;
  sessionDurationFilterValue: SearchFiltersType;
  applyButton?: ReactNode;
};

export default function SessionDurationFilter({
  open,
  handleImplicitFilterChange,
  onClose,
  onOpen,
  buttonSx,
  sessionDurationFilterValue,
  applyButton
}: SessionDurationFilterProps) {
  const { t } = useTranslation(
    "client\\components\\search\\SessionDurationFilter"
  );
  const sessionDurationOptions = [30, 45, 60];
  const { durationSessionMin } = sessionDurationFilterValue;

  const handleFilterChange = (_e: any, value: string) => {
    handleImplicitFilterChange("durationSessionsMin", {
      durationSessionMin: value
    });
  };

  return (
    <FilterDropdown
      filterName={t("Duration")}
      filterValue={
        durationSessionMin
          ? t("{{duration}} min and up", { duration: durationSessionMin })
          : t("Duration")
      }
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      buttonSx={buttonSx}
    >
      <FilterList>
        <Filter title={t("Duration per Session")}>
          <RadioGroup
            name="sessionDuration"
            value={durationSessionMin}
            options={sessionDurationOptions.map(duration => ({
              label: t("{{duration}} min and up", { duration }),
              value: String(duration)
            }))}
            onChange={handleFilterChange}
          />
        </Filter>
      </FilterList>
      {applyButton}
    </FilterDropdown>
  );
}
